import { render, staticRenderFns } from "./PaginationPageSize.vue?vue&type=template&id=64014fbe&scoped=true&"
import script from "./PaginationPageSize.vue?vue&type=script&lang=js&"
export * from "./PaginationPageSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64014fbe",
  null
  
)

export default component.exports